import React, { useContext } from 'react';
import {
    Heading, Button, Text, Flex,
    Spinner, Th, Thead, Tr, Td, Table, Tbody, Box
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import ThemeContext from '../../context/ThemeContext';

function SettingsCustomerListPaid({ customers, loadingCustomers }) {
    const navigate = useNavigate();
    const { themeData } = useContext(ThemeContext);

    // Extract theme colors with fallbacks
    const primaryColor = themeData?.colors?.primary || '#2B6CB0';
    const secondaryColor = themeData?.colors?.secondary || '#2C5282';
    const accentColor = themeData?.colors?.accent || '#4299E1';

    // Determine if theme is dark (midnight)
    const isDarkTheme = themeData?.id === 'midnight';

    // Theme-aware colors
    const headingTextColor = isDarkTheme ? '#F7FAFC' : primaryColor;
    const bodyTextColor = isDarkTheme ? '#E2E8F0' : 'gray.700';
    const mutedTextColor = isDarkTheme ? '#CBD5E0' : 'gray.500';
    const tableBg = isDarkTheme ? 'rgba(45, 55, 72, 0.6)' : 'white';
    const tableHeaderBg = isDarkTheme ? 'rgba(66, 153, 225, 0.15)' : 'gray.50';
    const tableStripedBg = isDarkTheme ? 'rgba(66, 153, 225, 0.08)' : 'gray.50';
    const borderColor = isDarkTheme ? 'rgba(66, 153, 225, 0.3)' : 'gray.200';
    const buttonHoverBg = isDarkTheme ? accentColor : secondaryColor;

    return (
        <>
            <Flex justify="space-between" align="center" mt={4} mb={4}>
                <Heading size="md" color={headingTextColor}>Customer List</Heading>
                <Button 
                    bg={primaryColor}
                    color="white"
                    _hover={{ bg: buttonHoverBg }}
                    onClick={() => navigate('/settings/manageCustomers')}
                >
                    Manage Customers
                </Button>
            </Flex>

            {loadingCustomers ? (
                <Flex justify="center" align="center" py={8}>
                    <Spinner color={isDarkTheme ? accentColor : primaryColor} size="lg" />
                </Flex>
            ) : customers.length > 0 ? (
                <Box
                    bg={tableBg}
                    borderRadius="lg"
                    borderWidth="1px"
                    borderColor={borderColor}
                    overflow="hidden"
                    boxShadow="md"
                    mb={10}
                >
                    <Table variant="simple" size="md">
                        <Thead bg={tableHeaderBg}>
                            <Tr>
                                <Th color={headingTextColor} borderColor={borderColor}>Customer ID</Th>
                                <Th color={headingTextColor} borderColor={borderColor}>Country</Th>
                                <Th color={headingTextColor} borderColor={borderColor}>Age</Th>
                                <Th color={headingTextColor} borderColor={borderColor}>Risk Profile</Th>
                                <Th color={headingTextColor} borderColor={borderColor}>Created At</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {customers.map((cust, index) => (
                                <Tr 
                                    key={cust.customer_id}
                                    bg={index % 2 === 1 ? tableStripedBg : 'transparent'}
                                    _hover={{
                                        bg: isDarkTheme ? 'rgba(66, 153, 225, 0.12)' : 'gray.100'
                                    }}
                                >
                                    <Td color={bodyTextColor} borderColor={borderColor}>{cust.customer_id}</Td>
                                    <Td color={bodyTextColor} borderColor={borderColor}>{cust.country_iso}</Td>
                                    <Td color={bodyTextColor} borderColor={borderColor}>{cust.age}</Td>
                                    <Td color={bodyTextColor} borderColor={borderColor}>{cust.risk_profile}</Td>
                                    <Td color={bodyTextColor} borderColor={borderColor}>
                                        {new Date(cust.created_at).toLocaleDateString()}
                                    </Td>
                                </Tr>
                            ))}

                            {customers.length >= 7 && (
                                <Tr>
                                    <Td 
                                        colSpan={5} 
                                        textAlign="center" 
                                        color={mutedTextColor} 
                                        fontWeight="bold"
                                        borderColor={borderColor}
                                    >
                                        ...
                                    </Td>
                                </Tr>
                            )}
                        </Tbody>
                    </Table>
                </Box>
            ) : (
                <Box
                    bg={tableBg}
                    borderRadius="lg"
                    borderWidth="1px"
                    borderColor={borderColor}
                    p={8}
                    textAlign="center"
                    boxShadow="md"
                >
                    <Text color={mutedTextColor}>
                        No customers found.
                    </Text>
                </Box>
            )}
        </>
    )
}

export default SettingsCustomerListPaid;